import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { Lock, Phone } from "lucide-react";

interface FeatureNotAvailableProps {
  featureName?: string;
  onClose?: () => void;
}

const FeatureNotAvailable = ({
  featureName = "Online Booking", 
  onClose 
}: FeatureNotAvailableProps) => {

  const { practice } = useSelector((s: RootState) => s.auth);
  
  return (
    <div className="flex items-center justify-center p-4">
      <div className="card border border-teamcare-blue-light/50 w-full max-w-md bg-base-100 shadow-xl">
        <div className="card-body items-center text-center">
          {/* Icon */}
          <div className="avatar placeholder mb-2">
            <div className="bg-neutral text-neutral-content w-16 rounded-full">
              <Lock className="w-8 h-8" />
            </div>
          </div>

          <h2 className="card-title text-lg">{featureName} Not Available</h2>

          <p className="text-base-content/60 text-sm">
            This feature is not currently activated for this practice. 
            Please contact the clinic directly to schedule your appointment.
          </p>

          <div className="divider text-xs text-base-content/40 uppercase">Contact Us</div>

          <div className="w-full space-y-3">
            <a
              href={`tel:${practice?.phone_number}`}
              className="flex items-center gap-3 p-3 rounded-box border border-base-300 hover:bg-base-200 transition-colors"
            >
              <div className="btn btn-circle btn-sm btn-info btn-outline">
                <Phone className="w-4 h-4" />
              </div>
              <div className="text-left">
                <p className="text-sm font-medium">Call Us</p>
                <p className="text-xs text-base-content/50">{practice?.phone_number}0</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureNotAvailable;
